// extracted by mini-css-extract-plugin
var _1 = "lmOdM5uf8cRsBDBaIGFX";
export { _1 as "input" }
